export const firebaseConfig = {
    apiKey: "AIzaSyB6alYPUQwE52yH4IxLZ__0_2RXpd2Lsk8",
    authDomain: "vanguard-gg.firebaseapp.com",
    projectId: "vanguard-gg",
    storageBucket: "vanguard-gg.appspot.com",
    messagingSenderId: "432416497098",
    appId: "1:432416497098:web:2a7319ba76205dcb854333",
    measurementId: "G-S267HYL6TH"
  };